// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_es-0";
export var actionModalContentContainer = "_es-1";
export var createTagButton = "_es-2";
export var footerContainer = "_es-7";
export var fullWidthDivider = "_es-3";
export var hasCreateTagButton = "_es-4";
export var noCreateTagButton = "_es-5";
export var tagsContainer = "_es-6";
export var tagsModalContentContainer = "_es-8";